import { render, staticRenderFns } from "./TicketsDetail.vue?vue&type=template&id=cf969f3a&scoped=true"
import script from "./TicketsDetail.vue?vue&type=script&lang=js"
export * from "./TicketsDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketsDetail.vue?vue&type=style&index=0&id=cf969f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf969f3a",
  null
  
)

export default component.exports